//libraries
import _ from 'lodash';

/**
 * Import all constants as an object.
 */
import * as ActionType from "../../constants/actionType";


var initialState = {
    companySettings: null,
    isCompanySettings: false,
    code: ""

};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export default function (state, action) {
    state = state || initialState;

    switch (action.type) {
        case ActionType.COMPANY_LOAD_SUCCESS:
            return _.assign({}, state, {
                companySettings: action.payload.company,
                isCompanySettings: true,
                code: action.payload.code,
            });

        case ActionType.LOG_IN_FAILURE:
            return _.assign({}, state, {
                companySettings: null,
                isCompanySettings: false,
                code: ""
            });

        case ActionType.LOG_OUT:
            return _.assign({}, state, {
                companySettings: null,
                isCompanySettings: false,
                code: ""
            });

        default:
            return state;
    }
}